/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FinalizeDisputeWonRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {FinalizeDisputeWonResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const finalizeDisputeWon = (request: FinalizeDisputeWonRequest, options?: CashRequestOptions) => post<FinalizeDisputeWonRequest, FinalizeDisputeWonResponse>("/2.0/cash/finalize-dispute-won", request, {...options, rejectOnError: true })